/**
 * Helpers for post-login redirects to deal-version file downloads (email links).
 */

const DEAL_VERSION_FILE_MARKERS = ["/excel/", "/pdf/", "/excelcompare/"];

/**
 * @param {string|null|undefined} raw
 * @returns {string|null}
 */
export function normalizePostLoginRedirect(raw) {
    if (raw == null || String(raw).trim() === "") {
        return null;
    }
    const value = String(raw).trim();
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

/**
 * True for absolute API URLs that serve deal-version export files (browser navigation / email links).
 * @param {string|null|undefined} url
 * @returns {boolean}
 */
export function isDealVersionFileDownloadUrl(url) {
    const normalized = normalizePostLoginRedirect(url);
    if (!normalized || !/^https?:\/\//i.test(normalized)) {
        return false;
    }
    const lower = normalized.toLowerCase();
    if (!lower.includes("/deal/version/")) {
        return false;
    }
    return DEAL_VERSION_FILE_MARKERS.some((marker) => lower.includes(marker));
}

/**
 * When the user already has a SPA session but must complete MYID again for the API-host download cookie.
 * @param {Object} params
 * @param {string|null|undefined} params.redirectPath
 * @param {boolean} params.tokenInUrl - Fresh ?token= from MYID ACS on this navigation
 * @param {boolean} params.hasAuthToken
 * @returns {boolean}
 */
export function shouldStayOnLoginForDealVersionDownload({
    redirectPath,
    tokenInUrl,
    hasAuthToken,
}) {
    if (!hasAuthToken || !redirectPath) {
        return false;
    }
    return (
        isDealVersionFileDownloadUrl(redirectPath) &&
        !tokenInUrl
    );
}
